import {ERROR_CONTENT, ERROR_SOURCES} from "app/components/sign/form/errorsData";

export class FormError {
    constructor({type, content} = {}) {
        this.type = type;
        this.content = content;
    }

    static createEmailType(content) {
        return new FormError({type: 'email', content});
    }

    static createPasswordType(content) {
        return new FormError({type: 'password', content});
    }

    static createPhoneType(content) {
        return new FormError({type: 'phone', content});
    }

    static createUsernameError(content) {
        return new FormError({type: 'username', content});
    }

    static createUnknownError() {
        return new FormError({type: null, content: ERROR_CONTENT.unknown_error});
    }

    static mapToThis(error) {
        if (!error) {
            return;
        }

        if (error instanceof FormError) {
            return error;
        }

        return new FormError({
            type: ERROR_SOURCES[error.source.pointer],
            content: ERROR_CONTENT[error.code],
        });
    }

    isType(type) {
        return this.type === type;
    }
}